import axios from 'axios';

const getList = async function adminsServiceGetList () {
  const response = await axios.get('/api/admin/');

  return response.data.data;
};

const getById = async function adminsServiceGetById (id) {
  const response = await axios.get(`/api/admin/${encodeURIComponent(id)}`);

  return response.data.data;
};

const create = async function adminsServiceCreate (data) {
  const response = await axios.post('/api/admin/', data);

  return response.data.data;
};

const update = async function adminsServiceUpdate (id, data) {
  const response = await axios.put(
    `/api/admin/${encodeURIComponent(id)}`,
    data,
  );

  return response.data.data;
};

const remove = async function adminsServiceRemove (id) {
  const response = await axios.delete(`/api/admin/${encodeURIComponent(id)}`);

  return response.data.data;
};

const generateToken = async function adminsServiceGenerateToken (id, data) {
  const response = await axios.post(
    `/api/admin/${encodeURIComponent(id)}/generateToken`,
    data,
  );

  return response.data.data;
};

export default {
  getList,
  getById,
  create,
  update,
  remove,
  generateToken,
};
